import { render, staticRenderFns } from "./BodyDesigns.vue?vue&type=template&id=f693073c&"
import script from "./BodyDesigns.vue?vue&type=script&lang=js&"
export * from "./BodyDesigns.vue?vue&type=script&lang=js&"
import style0 from "./BodyDesigns.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports